export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_USER_POSTS = "SET_USER_POSTS";